

// import React from "react";
// import { Box, Typography, IconButton, Stack, Button } from "@mui/material";
// import { Facebook, Instagram, Twitter, YouTube } from "@mui/icons-material";
// import { Link } from "react-router-dom";
// import XIcon from '@mui/icons-material/X';

// const Footer = () => {
//   const navLinks = [
//     { label: "About Us", path: "/about-us" },
//     { label: "Contact Us", path: "/contact-us" },
//     { label: "FAQ", path: "/faq" },
//   ];

//   return (
//     <Box
//       component="footer"
//       sx={{
//         backgroundColor: "#333",
//         color: "#fff",
//         py: 3,
//         px: 2,
//         mt: 4,
//       }}
//     >
//       {/* Top Section: Name on Left, Social Icons on Right */}
//       <Stack
//         direction="row"
//         justifyContent="space-between"
//         alignItems="center"
//         sx={{
//           flexWrap: "wrap",
//           mb: 2,
//         }}
//       >
//         {/* Website Name */}
//         <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//           Wedding Bliss
//         </Typography>

//          {/* Middle Section: Quick Links Column */}
//       <Stack
//         direction={{ xs: "column", sm: "row" }}
//         justifyContent="center"
//         spacing={4}
//         sx={{
//           mb: 2,
//           alignItems: "flex-start",
//         }}
//       >
//         <Box>
//           <Typography variant="h6" sx={{ fontWeight: "bold" }}>
//             Quick Links
//           </Typography>
//           <Stack direction="column" >
//             {navLinks.map((link) => (
//               <Button
//                 key={link.label}
//                 component={Link}
//                 to={link.path}
//                 sx={{
//                   color: "#fff",
//                   textTransform: "none",
//                   fontSize: { xs: "0.875rem", sm: "1rem" },
//                 }}
//               >
//                 {link.label}
//               </Button>
//             ))}
//           </Stack>
//         </Box>
//       </Stack>

//         {/* Social Media Icons */}
//         <Stack direction="row" spacing={2}>
//           <IconButton
//             component="a"
//             href="https://facebook.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             aria-label="Facebook"
//             sx={{ color: "#fff" }}
//           >
//             <Facebook />
//           </IconButton>
//           <IconButton
//             component="a"
//             href="https://instagram.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             aria-label="Instagram"
//             sx={{ color: "#fff" }}
//           >
//             <Instagram />
//           </IconButton>
//           <IconButton
//             component="a"
//             href="https://twitter.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             aria-label="Twitter"
//             sx={{ color: "#fff" }}
//           >
//             <XIcon />
//           </IconButton>
//           <IconButton
//             component="a"
//             href="https://youtube.com"
//             target="_blank"
//             rel="noopener noreferrer"
//             aria-label="YouTube"
//             sx={{ color: "#fff" }}
//           >
//             <YouTube />
//           </IconButton>
//         </Stack>


        
//       </Stack>

     

      
//       {/* Contact Information Section */}
//       <Box
//         sx={{
//           mt: 3,
//           textAlign: "center",
//           color: "#fff",
//         }}
//       >
//         <Typography variant="body2">
//           weddingbliss@gmail.com || +91 12345677890
//         </Typography>
//       </Box>

//       {/* Bottom Section: Copyright Line */}
//       <Typography
//         variant="body2"
//         align="center"
//         sx={{ borderTop: "1px solid #555", pt: 2, mt: 2 }}
//       >
//         © 2025 Wedding Bliss. All Rights Reserved.
//       </Typography>

//     </Box>
//   );
// };

// export default Footer;








import React from "react";
import { Box, Typography, IconButton, Stack, Button } from "@mui/material";
import { Facebook, Instagram, YouTube } from "@mui/icons-material";
import XIcon from "@mui/icons-material/X";
import { Link } from "react-router-dom";

const Footer = () => {
  const navLinks = [
    { label: "About Us", path: "/about-us" },
    { label: "Contact Us", path: "/contact-us" },
    { label: "FAQ", path: "/faq" },
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#333",
        color: "#fff",
        py: 4,
        px: 2,
        mt: 4,
      }}
    >
      {/* Wrapper to manage layout and responsiveness */}
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "center", md: "flex-start" }}
        spacing={{ xs: 3, md: 6 }}
        sx={{
          textAlign: { xs: "center", md: "left" },
          width: "100%",
        }}
      >
        {/* Website Name */}
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        Wedding Bliss
        </Typography>

        {/* Quick Links */}
        <Box>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            Quick Links
          </Typography>
          <Stack direction="column" spacing={1}>
            {navLinks.map((link) => (
              <Button
                key={link.label}
                component={Link}
                to={link.path}
                sx={{
                  color: "#fff",
                  textTransform: "none",
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                }}
              >
                {link.label}
              </Button>
            ))}
          </Stack>
        </Box>

        {/* Social Media Icons */}
        <Stack direction="row" spacing={2}>
          <IconButton
            component="a"
            href="https://facebook.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#fff" }}
          >
            <Facebook />
          </IconButton>
          <IconButton
            component="a"
            href="https://instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#fff" }}
          >
            <Instagram />
          </IconButton>
          <IconButton
            component="a"
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#fff" }}
          >
            <XIcon />
          </IconButton>
          <IconButton
            component="a"
            href="https://youtube.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#fff" }}
          >
            <YouTube />
          </IconButton>
        </Stack>
      </Stack>

      {/* Contact Information Section */}
      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Typography variant="body2">
          weddingbliss@gmail.com || +91 12345677890
        </Typography>
      </Box>

      {/* Bottom Section: Copyright */}
      <Typography
        variant="body2"
        align="center"
        sx={{ borderTop: "1px solid #555", pt: 2, mt: 2 }}
      >
        © 2025 weddingbliss Photography. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
